<template>
  <section v-if="has_children" class="invadobay-super-in">
    <b-row>
      <b-col cols="4">
        <vb-button
          class="semibold invadobay-super-in__title"
          :vb_options="{ text: super_in.title || super_in.name, variant: 'cta', size: 'sm' }"
        />
      </b-col>
      <b-col cols="8">
        <swiper
          ref_id="invadobay-super-in-children"
          class="invadobay-super-in__children"
          :swiper_params="slider_params"
        >
          <swiper-slide
            v-for="child in super_in.children"
            :key="child.id"
            class="invadobay-super-in__slide"
          >
            <vb-button
              :vb_options="{ text: child.title, variant: 'cta', size: 'sm' }"
              @click="$emit('select-child', child)"
            />
          </swiper-slide>
        </swiper>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Swiper from "@components/blocks/swiper.vue";

export default {
  name: "invadobay-super-in",

  components: {
    swiper: Swiper,
  },

  props: {
    super_in: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      slider_params: {
        classes: "invadobay-super-in__slider",
        slidesPerView: "auto",
        controls_size: 15,
        watchOverflow: true,
        hide_controls_on_lock: true,
        // Right-align the CTAs only while the track fits (locked); when it
        // overflows the slider scrolls normally (alignment off) — see swiper.vue.
        align_on_lock: "flex-end",
      },
    };
  },

  computed: {
    has_children() {
      return (
        Array.isArray(this.super_in.children) &&
        this.super_in.children.length > 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.invadobay-super-in {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: translateY(-100%);
  z-index: 100;
  max-width: 1175px;
  margin: 0 auto;
  padding: $grid-gutter-width / 2 0;

  .btn {
    height: 39px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: $gray-100;
    box-shadow: 3px 3px 5px 0 rgba(0, 0, 0, 0.1);
    font-size: $font-size-base;
  }

  &__title {
    pointer-events: none;
  }

  &__slide {
    width: auto;
    margin-left: 1rem;
  }

  &__children {
    .btn {
      font-size: $font-size-md;
      opacity: 0.9;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 1;
      }

      &:hover,
      &:focus,
      &:active {
        box-shadow: 3px 3px 5px 0 rgba(0, 0, 0, 0.1) !important;
      }
    }
  }

  &__slider {
    // Gutters for the arrows while overflowing; flush (no gutters) once the
    // track fits (locked → arrows hidden, CTAs right-aligned).
    padding: 0 28px;

    &.swiper--locked {
      padding: 0;
    }

    ::v-deep .swiper__button {
      top: 50% !important;
      transform: translateY(-50%) !important;
      background: transparent !important;
      box-shadow: none !important;

      &__prev {
        left: 0 !important;
      }

      &__next {
        right: 0 !important;
      }
    }

    ::v-deep .arrow {
      --color: #{$white} !important;
    }
  }
}
</style>
